// Base
import BaseIsland from './Base/index';
// 人机模式
import ManMachine from './ManMachine/index';
// 研究模式
import Resource from './Resource/index';
// 打谱模式
import Score from './Score/index';
// 练习模式
import Practice from './Practice/index';

export default {
  BaseIsland,
  ManMachine,
  Resource,
  Score,
  Practice
};
